import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; 
  width: 100vw; 
  position: fixed; 
  top: 0;
  left: 0;
  background-color: rgb(255, 255, 255); 
  z-index: 100; 
`;

export const Spinner = styled.div`
  border: 5px solid #f3f3f3; /* Light gray */
  border-top: 5px solid #1a8cd8ff; /* Blue */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${spin} 2s linear infinite;
`;